import { render, staticRenderFns } from "./allocate_inspection.vue?vue&type=template&id=835aaf9c"
import script from "./allocate_inspection.vue?vue&type=script&lang=js"
export * from "./allocate_inspection.vue?vue&type=script&lang=js"
import style0 from "./allocate_inspection.vue?vue&type=style&index=0&id=835aaf9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports